<!--
 * @Author: Merlin
 * @Date: 2024-04-04 13:19:33
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-15 17:29:21
 * @Description: 
-->
<template>
    <div>
        <div class="board">
            <div class="board-pharaon">
                <img src="@/pages/casino/corgipharaohGame/img/history/historyBg.webp" />
                <!-- ↑ 大背景 -->
                <!-- ↓ 开奖内容（bonus + 普通摇奖）--> 
                <template v-if="aGameResult.length == 3"> 
                    <img class="board-pharaon-bg2" src="@/pages/casino/corgipharaohGame/img/history/historyBG2.webp" />
                    <div class="board-pharaon-bonus">
                        <div v-for="(cur,idx) of aGameResult" :key="idx" >
                            <img :src="aPics[cur]" />
                        </div>
                    </div>
                </template>
                <!-- ↑ bonus -->
                <!-- ↓ 九宫格 -->
                <div v-else-if="history.randomSeed"
                    class="board-pharaon-simple"
                >
                    <div v-for="(cur,idx) of aGameResult" :key="idx">
                        <img :src="aPics[cur]" />
                    </div>
                </div>
                <!--  -->
            </div>
        </div>
    </div>
</template>

<script lang="ts" >
export default defineComponent({name: 'PharaohContent'});
</script>

<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const useCryptosImages = () => {
    let oImg = import.meta.glob('@/pages/casino/corgipharaohGame/img/history/*', { eager: true });
    const oResult = {};
    Object.entries(oImg).forEach((arr)=>{
        const [sKey, oVal] = arr;
        let sName = sKey.split('/').pop();
        sName = sName.split('.')[0];
        oResult[sName] = (oVal as any).default;
        
    });
    // console.log("oResult\n", oResult);
    return oResult;
};

const aPics = import.meta.client && useCryptosImages();


const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
        default: ()=>({}),
    },
});

const aGameResult = computed(()=>{
    const oHistory = props.history; 
    const {randomSeed='', isBonusGame} = (oHistory as any); 
    const sResult = randomSeed.split('_')[0];
    let arr = [];
    if (isBonusGame){
        // 3 位长度的 sResult
        arr = [...sResult].map(cur=>{
            return cur + 'r'; // 尾部加 r 以使与图片名相同 
        });
    }else if (sResult){
        // 9 位长度的 sResult
        arr = sResult.split(',');
        arr = [
            arr[0], arr[3], arr[6],
            arr[1], arr[4], arr[7],
            arr[2], arr[5], arr[8],
        ];
    }
    return arr;
});



</script>


<style scoped lang="scss">
.board {
    padding-top: 15px;
    width: 100%;
}

.has-height .board {
    width: calc(100% + 4px)
}

.board-pharaon {
    position: relative;
    // ↓ 追加 
    border-radius: 10px;
    overflow: hidden;
}

.board-pharaon-simple {
    display: flex;
    flex-wrap: wrap;
    height: -moz-max-content;
    height: max-content;
    left: 48.3%;
    position: absolute;
    top: 47%;
    transform: translate(-50%,-50%);
    width: 46%
}

.board-pharaon-simple div {
    padding-top: calc(33.33% / 1.16666);
    aspect-ratio: 1.16666;
    position: relative;
    width: 33.33%
}

.board-pharaon-simple div img {
    top: 50%
}

.board-pharaon-bonus,
.board-pharaon-simple div img {
    left: 50%;
    position: absolute;
    transform: translate(-50%,-50%)
}

.board-pharaon-bonus {
    display: flex;
    flex-wrap: wrap;
    height: -moz-max-content;
    height: max-content;
    top: 46%;
    width: 35%
}

.board-pharaon-bonus div {
    padding-top: calc(33.33% / 1.16666);
    aspect-ratio: 1.16666;
    position: relative;
    width: 33.33%
}

.board-pharaon-bonus div img {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%) scale(.5)
}

.midGoldLine {
    max-width: none;
    width: 300%;
    z-index: -1
}

.board-pharaon-bg2 {
    left: 0;
    position: absolute;
    top: 0
}

.winZero {
    left: 48.5%;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 50%
}

@media (max-width: 550px) {
    .winZero {
        left:50%
    }
}

@media (max-width: 782px) {
    .opened-left-panel .winZero {
        left:50%
    }
}

@media (max-width: 875px) {
    .opened-right-panel .winZero {
        left:50%
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .winZero {
        left:50%
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .winZero {
        left:50%
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .winZero {
        left:50%
    }
}

</style>


